export enum PageLayout {
  Default = 'default',
  Empty = 'empty',
  FooterOnly = 'footer-only',
  Maintenance = 'maintenance',
  Faq = 'faq',
  Page = 'page',
  Category = 'category',
  New = 'new-layout',
}
